import * as DataActions from "../../../shared/resources/data-actions";
import * as ActivityLogActions from "./activity-log.actions";
import * as AlulaReceiverBindActions from "./alula-receiver-bind.actions";
import * as AlulaReceiverGroupActions from "./alula-receiver-group.actions";
import * as AlulaReceiverActions from "./alula-receiver.actions";
import * as AlulaActions from "./alula.actions";
import * as CHServiceActions from "./ch-services.actions";
import * as ClareLogActions from "./clareone-log.actions";
import * as ClareSystemActions from "./claresystem.actions";
import * as CustomerServicePlanActions from "./customer-service-plans.actions";
import * as DeviceMetadataActions from "./device-metadata.actions";
import * as DevicesActions from "./devices.actions";
import * as EmergencyContactActions from "./emergency-contact.actions";
import * as GenericActionModel from "./generic.action";
import * as MunicipalityActions from "./municipalities.actions";
import * as ProjectFeatureActions from "./project-feature.actions";
import * as ProjectViewActions from "./project-view.actions";
import * as ProjectActions from "./projects.actions";
import * as ServiceMetadataActions from "./service-metadata.actions";
import * as ServicePlanActions from "./service-plans.actions";
import * as SubscriptionActions from "./subscriptions.actions";

export {
    ActivityLogActions,
    AlulaActions,
    AlulaReceiverActions,
    AlulaReceiverBindActions,
    AlulaReceiverGroupActions,
    CHServiceActions,
    ClareLogActions,
    ClareSystemActions,
    CustomerServicePlanActions,
    DataActions,
    DeviceMetadataActions,
    DevicesActions,
    EmergencyContactActions,
    GenericActionModel,
    MunicipalityActions,
    ProjectActions,
    ProjectFeatureActions,
    ProjectViewActions,
    ServiceMetadataActions,
    ServicePlanActions,
    SubscriptionActions,
};
